(function($, Drupal, drupalSettings) {

  Drupal.webform = Drupal.webform || {};
  Drupal.webform.select2 = Drupal.webform.select2 || {};
  Drupal.webform.select2.options = Drupal.webform.select2.options || {};
  Drupal.webform.select2.options.width = Drupal.webform.select2.options.width || '100%';
  Drupal.webform.select2.options.widthInline = Drupal.webform.select2.options.widthInline || '50%';

  Drupal.behaviors.register_form = {
    attach: function (context, settings) {

      if ($('body').hasClass('page--user--register')) {
        $('.user-register-form #edit-actions').addClass('mba_btn_001a');
        var options = {};
        options.width = Drupal.webform.select2.options.widthInline;
        options = $.extend(options, Drupal.webform.select2.options);
        $('select.form-select').chosen('destroy');
        $('select.form-select').select2(options);

      }

    }
  }; // Drupal.behaviors.register_form

})(jQuery, Drupal, drupalSettings);
